<template>
  <div class="sd-loader" v-if="!isResults">
    <img src="/static/geopsicon.gif" height="40" width="40" v-if="loader"/>
    <img src="/static/icon.png" height="40" width="40"
      v-if="!loader && !isResults"
    />
    <br><br>
    <a class="sd-error" v-if="!loader">Keine Ergebnisse</a>
    <span v-if="errorMessage">
      <h1>{{ this.errorMessage }}</h1>
      <a href="http://geops.ch/impressum" class="sd-contact">geOps Kontakt</a>
    </span>
  </div>
</template>

<script>
export default {
  name: 'sd-loader',
  props: [
    'loader',
    'isResults',
    'errorMessage',
  ],
};
</script>

<style lang="scss">
@import "./../Globals.scss";

.sd-loader {
  padding-top: 150px;
  padding-bottom: 150px;

  a {
    color: $sd-color-blue;
    font-weight: bold;
  }

  .sd-contact {
    font-weight: normal;
  }
}
</style>


// WEBPACK FOOTER //
// LoaderAnimation.vue?593f4b9f